import React from "react";
import PropTypes from "prop-types";
import StyledTooltip from "../tooltips/StyledTooltip";
import {find} from "underscore";

const ItemTooltip = ({children, item, name, options}) => {
  let tooltipValue = item?.description;
  if (!tooltipValue && name) {
    const option = find(
      options,
      (option) => option?.value === name || option?.name === name,
    );
    tooltipValue = option?.description;
  }
  if (!tooltipValue) {
    return children || null;
  }
  return (
    <StyledTooltip title={tooltipValue} placement="right">
      {children}
    </StyledTooltip>
  );
};

ItemTooltip.propTypes = {
  children: PropTypes.any,
  item: PropTypes.object,
  name: PropTypes.string,
  options: PropTypes.array,
};

export default ItemTooltip;
